import {Component, computed, inject, signal} from '@angular/core';
import {TranslocoDirective} from '@jsverse/transloco';
import {TabsModule} from 'primeng/tabs';
import {
  ProviderTenderView,
  TenderPhaseType,
  ProviderTenderControllerService,
} from '@frontend/shared-api';
import {DataViewGridComponent} from '../../../shared/components/dataview-grid/data-view-grid.component';
import {TenderCardComponent} from './components/tender-card/tender-card.component';
import {Router} from '@angular/router';
import {APP_ROUTES} from '../../../app.routes';
import {
  ScoresModalMode,
  SubcriteriaScoresModalComponent,
} from '../../../shared/components/subcriteria-scores-modal/subcriteria-scores-modal.component';
import {Badge} from 'primeng/badge';
import {rxResource} from '@angular/core/rxjs-interop';
import {LoadingComponent} from '../../../shared/components/loading/loading.component';
import {NoDataComponent} from '../../../shared/components/no-data/no-data.component';
import {TabsUnsavedRevealDirective} from '../../../shared/tabs/tabs-unsaved-reveal.directive';

@Component({
  imports: [
    TranslocoDirective,
    TabsModule,
    DataViewGridComponent,
    TenderCardComponent,
    SubcriteriaScoresModalComponent,
    Badge,
    LoadingComponent,
    NoDataComponent,
    TabsUnsavedRevealDirective,
  ],
  templateUrl: './tender-list.component.html',
})
export class TenderListComponent {
  protected readonly TenderPhaseType = TenderPhaseType;
  protected readonly ScoresModalMode = ScoresModalMode;

  private readonly providerTenderController = inject(ProviderTenderControllerService);
  private readonly router = inject(Router);

  protected readonly subcriteriaScoresModalVisible = signal(false);
  protected readonly selectedTender = signal<ProviderTenderView | null>(null);
  protected readonly activeTabIndex = signal(0);

  protected readonly tendersAllResource = rxResource({
    stream: () => this.providerTenderController.getAllTenders(),
  });

  protected readonly inProgressTenders = computed(
    () => this.tendersAllResource.value()?.inProgressTenders ?? [],
  );
  protected readonly wonTenders = computed(() => this.tendersAllResource.value()?.wonTenders ?? []);
  protected readonly lostTenders = computed(
    () => this.tendersAllResource.value()?.lostTenders ?? [],
  );
  protected readonly allTenders = computed(() => [
    ...this.inProgressTenders(),
    ...this.wonTenders(),
    ...this.lostTenders(),
  ]);

  protected onAnswerRequest(tender: ProviderTenderView): void {
    const phase = tender?.activePhaseStatusInfo?.phase;
    if (phase) {
      void this.router.navigate([
        APP_ROUTES.PROVIDER_TENDER,
        tender.tenderMappingId,
        phase.toLowerCase(),
      ]);
    }
  }
}
